var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"list-group"},[_c('vue-good-table',{attrs:{"columns":_vm.tableColumns,"rows":_vm.list,"styleClass":"vgt-table striped condensed","search-options":{
      enabled: true}},scopedSlots:_vm._u([{key:"table-row",fn:function(props){return [(props.column.field == 'actions')?_c('span',[_c('b-button',{on:{"click":function($event){return _vm.changeSelected(props.row)}}},[_vm._v("Modifica")])],1):_vm._e()]}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }